import _ from 'lodash';
import DataHelper from './dataHelper';
import InsurersFullName from '@json/InsurersFullName.json';
class SummaryView {
	constructor(calculation, contract, formData, store, real_estate = null) {
		this.calculationData = calculation;
        if(real_estate) {
            this.realEstateData = real_estate;
            this.outbuildingsData = real_estate?.outbuilding;
            this.movablesData = real_estate?.movables;
            this.valuablesData = real_estate?.valuables;
        } else{
            this.realEstateData = calculation.real_estate;
            this.outbuildingsData = calculation.real_estate?.outbuilding;
            this.movablesData = calculation.real_estate?.movables;
            this.valuablesData = calculation.real_estate?.valuables;
        }

		this.contractData = contract;
		this.formData = formData;
		this.store = store;
	}

	get titles() {
		const titles = {
			contracterDetails: 'Szerződő adatok',
			realEstate: 'Ingatlan adatok',
			contractDetails: 'Szerződés adatok',
			insured: this.contractData?.insurer_code === 'GEN' ? 'Biztosítottak adatai' : 'Biztosított adatok',
			financing: 'Finanszírozási adatok',
			mainMovables: 'Főépület ingóságok',
			valuables: 'Értéktárgyak',
			outbuildings: 'Melléképületek',
			movables: 'Melléképület ingóságok',
			buildings: 'Építmények',
			containers: 'Tárolók',
			containerMovables: 'Tároló ingóságok',
			beneficiaryData: 'Balesetbiztosítás adatai',
			insuranceEvents: 'Kiegészítő biztosítások',
		};

		const outbuildingType = _.find(
			this.realEstateData.outbuildings,
			outbuilding => outbuilding.type_id === 9,
		);

		const outbuildingLocation = _.find(
			this.realEstateData.outbuildings,
			outbuilding => outbuilding.location_id === 1,
		);

		if (this.contractData?.insurer_code !== 'ALL') {
			delete titles.containers;
			delete titles.containerMovables;
		}

		if (this.realEstateData?.type !== 0 && outbuildingType === undefined && outbuildingLocation === undefined) {
			delete titles.containers;
			delete titles.containerMovables;
		}

		const offerInsuranceEvents = _.find(
			this.contractData?.insurance_events,
			insurance_event => insurance_event.included && insurance_event.name === 'Balesetbiztosítás',
		);

		if (offerInsuranceEvents === undefined) {
			delete titles.beneficiaryData;
		}

		return titles;
	}

	get contracterDetails() {
		return [
			{ title: 'Szerződő', value: 'Magánszemély' },
			{ title: 'Vezetéknév', value: this.formData.baseData?.contractDetails?.last_name ?? null },
			{ title: 'Keresztnév', value: this.formData.baseData?.contractDetails?.first_name ?? null },
			{ title: 'Születési név', value: this.formData.baseData?.contractDetails?.birth_name ?? null },
			{ title: 'Anyja neve', value: this.formData.baseData?.contractDetails?.mother_name ?? null },
			{ title: 'Születési hely', value: this.formData.baseData?.contractDetails?.birth_city ?? null },
			{
				title: 'Születési dátum',
				value: this.formData.baseData?.contractDetails?.birth_date.replaceAll('-', '.') ?? null,
			},
			{ title: 'Email cím', value: this.formData.baseData?.contractDetails?.email ?? null },
			{ title: 'Mobil', value: this.formData.baseData?.contractDetails?.mobile_number ?? null },
			{ title: 'Telefon', value: this.formData.baseData?.contractDetails?.phone_number ?? null },
		];
	}

	get contractDetails() {
		let base = [
			{ title: 'Biztosító neve', value: this.contractData?.insurer_full_name ?? null },
			{
				title: 'Szerződéskötés oka',
				value: this.calculationData?.is_new_contract ? 'Új szerződés' : 'Lakásbiztosítás váltás' ?? null,
			},
			{
				title: 'Díjfizetés módja',
				value: DataHelper.getData('PAYMENT_METHODS', this.calculationData?.payment_method) ?? null,
			},
			{
				title: 'Díjfizetés gyakorisága',
				value: DataHelper.getData('PAYMENT_FREQUENCY', this.calculationData?.payment_frequency) ?? null,
			},
			{ title: 'Éves díj', value: this.toCurrency(this.contractData?.annual_fee) ?? null },
			{
				title: 'Kockázatviselés kezdete',
				value: this.calculationData?.start_of_risk.replaceAll('-', '.') ?? null,
			},
			{
				title: 'Online kommunikáció',
				value: this.calculationData?.is_online_communication ? 'Igen' : 'Nem' ?? null,
			},
			{
				title: 'Online kárrendezés',
				value: this.calculationData?.is_online_claims_settlement ? 'Igen' : 'Nem' ?? null,
			},
		];

		if (this.calculationData?.on_my_own) {
			base.push({
				title: 'Jelenlegi szerződésem felmondásáról magam gondoskodom',
				value: this.calculationData?.on_my_own ? 'Igen' : 'Nem' ?? null,
			});
		}

		return base;
	}

	get insured() {
		if (this.contractData?.insurer_code === 'GEN') {
			let insuredsData = [];

			_.each(this.formData.insuredData?.insuredsData, (insured, index) => {
				insuredsData.push({
					title: `${index}. Biztosított neve`,
					value: `${insured.last_name} ${insured.first_name}` ?? null,
				});
				insuredsData.push({
					title: `${index}. Biztosított születési dátuma`,
					value: insured.birth_date.replaceAll('-', '.') ?? null,
				});
			});

			return insuredsData;
		}

		return [
			{ title: 'Vezetéknév', value: this.formData.insuredData?.contractDetails?.last_name ?? null },
			{ title: 'Keresztnév', value: this.formData.insuredData?.contractDetails?.first_name ?? null },
			{ title: 'Születési név', value: this.formData.insuredData?.contractDetails?.birth_name ?? null },
			{ title: 'Anyja neve', value: this.formData.insuredData?.contractDetails?.mother_name ?? null },
			{ title: 'Születési hely', value: this.formData.insuredData?.contractDetails?.birth_city ?? null },
			{
				title: 'Születési dátum',
				value: this.formData.insuredData?.contractDetails?.birth_date.replaceAll('-', '.') ?? null,
			},
			{ title: 'Email cím', value: this.formData.insuredData?.contractDetails?.email ?? null },
			{ title: 'Mobil', value: this.formData.insuredData?.contractDetails?.mobile_number ?? null },
			{ title: 'Telefon', value: this.formData.insuredData?.contractDetails?.phone_number ?? null },
			{ title: 'Állandó lakcím', value: this.makeAddress(this.formData.insuredData?.permanentAddress) ?? null },
			{ title: 'Levelezési cím', value: this.makeAddress(this.formData.insuredData?.mailingAddress) ?? null },
		];
	}

	get realEstate() {
		const insuranceValue =
			this.toCurrency(this.realEstateData?.insurance_value) ??
			this.toCurrency(parseInt(this.contractData?.detailedInsuranceValues?.main?.insurance_value));

        const condominium = this.realEstateData?.type === 0 ? [
            { title: 'Van a társasháznak biztosítása?', value: this.calculationData?.has_condominium_insurance ? 'Igen' : 'Nem' ?? null },
            { title: 'Társasház biztosítója', value: this.calculationData?.condominium_insurer ? InsurersFullName[this.calculationData?.condominium_insurer] : '-' ?? null },
        ] : [];

		return [
			{ title: 'Irányítószám', value: this.realEstateData?.postal_code ?? null },
			{ title: 'Város', value: this.realEstateData?.city ?? null },
			{ title: 'Cím', value: this.makeRealEstateAddress(this.realEstateData) ?? null },
			{ title: 'Építés éve', value: this.realEstateData?.year ?? null },
			{ title: 'Alapterület', value: `${this.realEstateData?.floor_area} m2` ?? null },
			{ title: 'Biztosítási összeg', value: insuranceValue },
			{ title: 'Együtt lakók száma', value: `${this.realEstateData?.inhabitants} fő` ?? null },
			{ title: 'Tulajdonjog', value: DataHelper.getData('OWNERSHIP', this.realEstateData?.ownership) ?? null },
			{
				title: 'Ingatlan típusa',
				value: DataHelper.getData('REAL_ESTATE_TYPE', this.realEstateData?.type) ?? null,
			},
			{ title: 'Épület fala', value: DataHelper.getData('WALL_TYPE', this.realEstateData?.wall_type) ?? null },
			{ title: 'Épület teteje', value: DataHelper.getData('ROOF_TYPE', this.realEstateData?.roof_type) ?? null },
			{
				title: 'Az ingatlan építés alatt áll',
				value: this.realEstateData?.under_construction ? 'Igen' : 'Nem' ?? null,
			},
			{
				title: 'Az ingatlan állandóan lakott',
				value: this.realEstateData?.is_permanently_inhabited ? 'Igen' : 'Nem' ?? null,
			},
			{
				title: 'Az ingatlan külterületen fekszik',
				value: this.realEstateData?.is_public_space ? 'Igen' : 'Nem' ?? null,
			},
			{ title: 'Az ingatlanon van jelzálog', value: this.realEstateData?.mortgage ? 'Igen' : 'Nem' ?? null },
            ...condominium,
		];
	}

	get financing() {
		let financersData = [];

		_.each(_.keys(this.formData.financingData?.creditorDetails), index => {
			financersData.push({
				title: `${index}. Finanszírozó neve`,
				value: this.formData.financingData?.creditorDetails[index]?.name ?? null,
			});
			financersData.push({
				title: `${index}. Finanszírozó címe`,
				value: this.makeAddress(this.formData.financingData?.creditorDetails[index]) ?? null,
			});
			financersData.push({
				title: `${index}. Finanszírozási szerződés száma`,
				value: this.formData.financingData?.lendingDetails[index]?.contract_number ?? null,
			});
			financersData.push({
				title: `${index}. Finanszírozási szerződés típusa`,
				value: this.formData.financingData?.lendingDetails[index]?.type ?? null,
			});
			financersData.push({
				title: `${index}. Szerződött összeg`,
				value: this.toCurrency(this.formData.financingData?.lendingDetails[index]?.amount) ?? null,
			});
			financersData.push({
				title: `${index}. Pénznem`,
				value:
					DataHelper.getData('CURRENCY', this.formData.financingData?.lendingDetails[index]?.currency) ??
					null,
			});
			financersData.push({
				title: `${index}. Finanszírozás kezdete`,
				value: this.formData.financingData?.lendingDetails[index]?.start_date.replaceAll('-', '.') ?? null,
			});
			financersData.push({
				title: `${index}. Finanszírozás vége`,
				value: this.formData.financingData?.lendingDetails[index]?.end_date.replaceAll('-', '.') ?? null,
			});
		});

		return financersData;
	}

	get buildings() {
		if (this.realEstateData?.buildings.length > 0) {
			let buildingsData = [];

			if (this.contractData?.insurer_code === 'UNI') {
				_.each(this.realEstateData?.buildings, (building, index) => {
					buildingsData.push({
						title: `${index + 1}. építmény típusa`,
						value: DataHelper.getData('BUILDING_TYPE', building.type) ?? null,
					});
					buildingsData.push({
						title: `${index + 1}. építmény biztosítási összege`,
						value: this.toCurrency(building.insurance_value) ?? null,
					});
				});
			} else {
				buildingsData.push({
					value: `Tájékoztatjuk, hogy a(z) ${this.contractData?.insurer_name ??
						null} MFO terméke esetén az Építmények biztosítási összegét a Főépület biztosítási összege tartalmazza!`,
				});
			}

			return buildingsData;
		}

		return [];
	}

	get containers() {
		if (this.realEstateData?.outbuildings.length > 0) {
			let outbuildingsData = [];
			const outbuildings = this.realEstateData.outbuildings.filter(outbuilding => outbuilding.type_id === 9);

			_.each(outbuildings, (outbuilding, index) => {
				outbuildingsData.push({
					title: `${index + 1}. tároló alapterület`,
					value: `${outbuilding.floor_area} m2` ?? null,
				});
				outbuildingsData.push({
					title: `${index + 1}. tároló biztosítási összege`,
					value: this.toCurrency(outbuilding.insurance_value) ?? null,
				});
			});

			return outbuildingsData;
		}

		return [];
	}

	get containerMovables() {
		if (this.realEstateData?.outbuildings.length > 0) {
			const outbuildings = this.realEstateData.outbuildings.filter(outbuilding => outbuilding.type_id === 9);
			let outbuildingsData = [];

			_.each(outbuildings, (outbuilding, index) => {
				outbuildingsData.push({
					title: `${index + 1}. tároló`,
					value: this.toCurrency(outbuilding.movable_value) ?? null,
				});
			});

			return outbuildingsData;
		}

		return [];
	}

	get outbuildings() {
		if (this.realEstateData?.outbuildings.length > 0) {
			let outbuildingsData = [];
			const outbuildings =
				this.contractData?.insurer_code === 'ALL'
					? this.realEstateData.outbuildings.filter(outbuilding => outbuilding.type_id !== 9)
					: this.realEstateData.outbuildings;

			_.each(outbuildings, (outbuilding, index) => {
				outbuildingsData.push({
					title: `${index + 1}. melléképület alapterület`,
					value: `${outbuilding.floor_area} m2` ?? null,
				});
				outbuildingsData.push({
					title: `${index + 1}. melléképület biztosítási összege`,
					value: this.contractData?.insurer_code === 'ALF' ? this.toCurrency(this.store.getters.getOffer(this.contractData?.insurer_uuid)?.detailedInsuranceValues.outbuilding[index]?.insurance_value) : this.toCurrency(outbuilding.insurance_value),
				});
				outbuildingsData.push({
					title: `${index + 1}. melléképület fala`,
					value: DataHelper.getData('WALL_TYPE', outbuilding.wall_type) ?? null,
				});
				outbuildingsData.push({
					title: `${index + 1}. melléképület teteje`,
					value: DataHelper.getData('ROOF_TYPE', outbuilding.roof_type) ?? null,
				});
				outbuildingsData.push({
					title: `${index + 1}. melléképület típusa`,
					value: this.store.getters.getOutbuildingTypeById(outbuilding.type_id) ?? null,
				});
				outbuildingsData.push({
					title: `${index + 1}. melléképület elhelyezkedése`,
					value: this.store.getters.getOutbuildingLocationById(outbuilding.location_id) ?? null,
				});
			});

			return outbuildingsData;
		} else {
			return [];
		}
	}

	get mainMovables() {
		if (this.realEstateData?.movables.length > 0) {
			let results = [];

			_.each(this.realEstateData.movables, movable => {
				results.push({ title: movable.type_name, value: this.toCurrency(movable.insurance_value) });
			});

			return results;
		} else {
			return [
				{
					title: 'Biztosítási összeg',
					value:
						this.toCurrency(this.realEstateData?.movable_value) ??
						this.toCurrency(parseInt(this.contractData?.detailedInsuranceValues?.main?.movable_value)) ??
						this.toCurrency(parseInt(this.contractData?.movables_value)),
				},
			];
		}
	}

	get valuables() {
		if (this.realEstateData?.valuables.length > 0) {
			let results = [];

			_.each(this.realEstateData.valuables, valuable => {
				results.push({ title: valuable.type_name, value: this.toCurrency(valuable.insurance_value) });
			});

			return results;
		} else {
			if (this.realEstateData?.valuable_value === 0 || this.realEstateData?.valuable_value === null) {
				return [{ title: 'Biztosítási összeg', value: this.toCurrency(200000) ?? null }];
			}

			return [
				{ title: 'Biztosítási összeg', value: this.toCurrency(this.realEstateData?.valuable_value) ?? null },
			];
		}
	}

	get movables() {
		if (this.realEstateData?.outbuildings.length > 0) {
			let outbuildingsData = [];

			const outbuildings =
				this.contractData?.insurer_code === 'ALL'
					? this.realEstateData.outbuildings.filter(outbuilding => outbuilding.type_id !== 9)
					: this.realEstateData.outbuildings;

			_.each(outbuildings, (outbuilding, index) => {
				outbuildingsData.push({
					title: `${index + 1}. melléképület`,
					value: this.toCurrency(outbuilding.movable_value) ?? null,
				});
			});

			return outbuildingsData;
		} else {
			return [];
		}
	}

	get insuranceEvents() {
		const offerInsuranceEvents = _.filter(
			this.contractData?.insurance_events,
			insurance_event => insurance_event.included,
		);
		let insuranceEvents = [];

		if (offerInsuranceEvents.length > 0) {
			_.each(offerInsuranceEvents, offerInsuranceEvent => {
                if(offerInsuranceEvent.id !== 22) {
				    insuranceEvents.push({ title: offerInsuranceEvent.name, value: 'Igen' });
                }
			});
		}

		if (this.realEstateData?.valuable_value > 200000) {
			insuranceEvents.push({ title: 'Értéktágy kiegészítő biztosítás Fedezeti összeg: '+(new Intl.NumberFormat('hu-HU', {
                    style: 'currency',
                    currency: 'HUF',
                    minimumFractionDigits: 0,
                }).format(this.realEstateData?.valuable_value-200000))+' (200 eFt-ig az alapcsomag nyújt fedezetet)', value: 'Igen' });
		}

		return insuranceEvents;
	}

	get beneficiaryData() {
		if (this.formData.baseData?.beneficiaryData) {
			let beneficiaryData = [];

			_.each(_.keys(this.formData.baseData.beneficiaryData), index => {
				const beneficiary = this.formData.baseData.beneficiaryData[index];
				const addresss = this.makeAddress(beneficiary);

				beneficiaryData.push({ title: `${index}. kedvezményezett neve`, value: `${beneficiary.name}` ?? null });
				beneficiaryData.push({
					title: `${index}. kedvezményezett aránya`,
					value: `${beneficiary.rate}%` ?? null,
				});
				beneficiaryData.push({
					title: `${index}. kedvezményezett anyja neve`,
					value: `${beneficiary.mother_name}` ?? null,
				});
				beneficiaryData.push({
					title: `${index}. kedvezményezett születési dátuma`,
					value: `${beneficiary.birth_date}` ?? null,
				});
				beneficiaryData.push({
					title: `${index}. kedvezményezett születési helye`,
					value: `${beneficiary.birth_city}` ?? null,
				});
				beneficiaryData.push({ title: `${index}. kedvezményezett címe`, value: `${addresss}` ?? null });
			});

			return beneficiaryData;
		} else if (this.formData.baseData?.insuredsData) {
			let insuredsData = [];

			_.each(_.keys(this.formData.baseData.insuredsData), index => {
				const insured = this.formData.baseData.insuredsData[index];

				insuredsData.push({
					title: `${index}. biztosított vezetékneve`,
					value: `${insured.last_name}` ?? null,
				});
				insuredsData.push({
					title: `${index}. biztosított keresztneve`,
					value: `${insured.first_name}` ?? null,
				});
				insuredsData.push({
					title: `${index}. biztosított születési helye`,
					value: `${insured.birth_city}` ?? null,
				});
				insuredsData.push({
					title: `${index}. biztosított születési dátuma`,
					value: `${insured.birth_date}` ?? null,
				});
			});

			return insuredsData;
		} else {
			return [];
		}
	}

	toCurrency(value) {
		if (typeof value !== 'number') {
			return value;
		}

		if (value === null || value === undefined || isNaN(value)) {
			return null;
		}

		var formatter = new Intl.NumberFormat('hu-HU', {
			style: 'currency',
			currency: 'HUF',
			minimumFractionDigits: 0,
		});

		return formatter.format(value);
	}

	makeRealEstateAddress(data) {
		if (data !== undefined) {
			let address = `${data.address} ${data.house_number}`;

			if (data.house_number_to !== null && data.house_number_to !== undefined) {
				address += ` - ${data.house_number_to}`;
			}

			if (data.building !== null && data.building !== undefined) {
				address += ` ${data.building}. épület`;
			}

			if (data.stairway !== null && data.stairway !== undefined) {
				address += ` ${data.stairway}. lépcsőház`;
			}

			if (data.floor !== null && data.floor !== undefined) {
				if (isNaN(parseInt(data.floor))) {
					address += ` ${data.floor}`;
				} else {
					address += ` ${data.floor}. em.`;
				}
			}

			if (data.door !== null && data.door !== undefined) {
				address += ` ${data.door}. ajtó`;
			}

			return address;
		}

		return null;
	}

	makeAddress(data) {
		if (data !== undefined) {
			let address = `${data.postal_code} ${data.city}, ${data.address_name} ${data.address_type} ${data.from_house_number}`;

			if (data.to_house_number !== null && data.to_house_number !== undefined) {
				address += ` - ${data.to_house_number}`;
			}

			if (data.building !== null && data.building !== undefined) {
				address += ` ${data.building}. épület`;
			}

			if (data.stairway !== null && data.stairway !== undefined) {
				address += ` ${data.stairway}. lépcsőház`;
			}

			if (data.floor !== null && data.floor !== undefined) {
				address += ` ${data.floor}. em.`;
			}

			if (data.door !== null && data.door !== undefined) {
				address += ` ${data.door}. ajtó`;
			}

			return address;
		}

		return null;
	}

	getData() {
		let data = [];

		_.each(this.titles, (title, key) => {
			data.push({
				title,
				open: key === 'contracterDetails' || key === 'realEstate',
				class: key === 'insuranceEvents' ? 'mt-30px' : '',
				items: this[key],
				hasItems: this[key].filter(item => item.value !== null).length > 0,
				key: key,
			});
		});

		return data;
	}
}

export default SummaryView;
